import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { FiMessageSquare, FiCheck, FiX, FiPlus, FiTrash2, FiZap } from 'react-icons/fi';

const SimulationStepEditor = ({ step, onUpdate }) => {
  const updateOption = (optId, updates) => {
    const newOptions = step.options.map(opt => 
      opt.id === optId ? { ...opt, ...updates } : opt
    );
    onUpdate({ ...step, options: newOptions });
  };

  return (
    <div className="space-y-6 bg-slate-50 p-4 md:p-6 rounded-2xl border border-slate-200">
      <div className="space-y-2">
        <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
          Active Diagnostic Question
        </label>
        <textarea 
          value={step.question}
          onChange={(e) => onUpdate({...step, question: e.target.value})}
          className="w-full bg-white border border-slate-200 rounded-xl p-4 text-sm font-bold text-slate-800 outline-none focus:ring-2 focus:ring-blue-500 transition-all resize-none"
          rows={3}
        />
      </div>

      <div className="space-y-4">
        <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">
          Resolution Options (Answers)
        </label>
        {step.options.map((option, idx) => (
          <div key={option.id} className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm space-y-3 relative overflow-hidden">
            <div className={`absolute top-0 left-0 w-1 h-full ${option.correct ? 'bg-emerald-500' : 'bg-red-500'}`} />
            
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <div className="flex-1 w-full">
                <input 
                  value={option.text}
                  onChange={(e) => updateOption(option.id, { text: e.target.value })}
                  placeholder="Option text..."
                  className="w-full text-sm font-bold text-slate-700 outline-none border-b border-transparent focus:border-blue-200 pb-1"
                />
              </div>
              <div className="flex items-center space-x-2 shrink-0 self-end sm:self-auto">
                <button 
                  onClick={() => updateOption(option.id, { 
                    correct: !option.correct,
                    nextStep: !option.correct ? 'success' : 'fail_error'
                  })}
                  className={`flex-1 sm:flex-none px-3 py-1.5 rounded-lg text-[10px] font-black uppercase transition-all ${
                    option.correct ? 'bg-emerald-100 text-emerald-700' : 'bg-slate-100 text-slate-400 hover:bg-slate-200'
                  }`}
                >
                  {option.correct ? 'Correct' : 'Incorrect'}
                </button>
                <div className="flex items-center bg-slate-100 rounded-lg px-2 py-1.5 border border-slate-200">
                  <SafeIcon icon={FiZap} className="text-blue-500 text-[10px] mr-1" />
                  <input 
                    type="number" 
                    value={option.points}
                    onChange={(e) => updateOption(option.id, { points: parseInt(e.target.value) || 0 })}
                    className="w-10 bg-transparent text-[10px] font-black text-slate-600 outline-none text-center"
                  />
                </div>
              </div>
            </div>

            <div className="flex items-start sm:items-center gap-2 bg-slate-50 p-2.5 rounded-lg border border-slate-100">
              <SafeIcon icon={FiMessageSquare} className="text-slate-400 text-xs shrink-0 mt-0.5 sm:mt-0" />
              <input 
                value={option.feedback}
                onChange={(e) => updateOption(option.id, { feedback: e.target.value })}
                placeholder="Expert feedback for this choice..."
                className="w-full bg-transparent text-xs text-slate-500 italic outline-none"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SimulationStepEditor;